import { formatNumberWithDecimals } from "@/common/helpers/util.functions";
import styles from "./priceDisplay.module.scss";
import { Cart } from "@/common/entities/cart/CartItem";
import { Spinner } from "react-bootstrap";

interface PriceDisplayProps {
    cart?: Cart;
}

const PriceDisplay = ({ cart }: PriceDisplayProps) => {
    if (!cart) {
        return <Spinner animation="border" />;
    }

    const renderAdditionalCosts = () => {
        const transport = cart?.otherCosts?.find((item) => item.name === "COST_TRANSPORT");
        if (!transport) {
            cart?.otherCosts?.push({ name: "COST_TRANSPORT", price: "0" });
        }

        const costItems = cart?.otherCosts?.map((cost, index) => {
            let displayName = cost.name.toUpperCase().replace(/_/g, " ");
            if (cost.name === "payAtDelivery") {
                displayName = "TAXA NUMERAR LA LIVRARE";
            }

            if (cost.name === "COST_TRANSPORT") {
                displayName = "TRANSPORT";
            }

            return (
                <div key={index}>
                    <br />
                    <span className={styles.summaryText}>{displayName}:</span>
                    <span className={styles.summaryTotal}>{Number(cost.price) === 0 ? "GRATUIT" : formatNumberWithDecimals(cost.price) + " LEI"}</span>
                </div>
            );
        });

        return costItems;
    };

    const calculateTotalWithOtherCosts = () => {
        const baseTotal = Number(cart.totalCostWithVat);
        const additionalCostsTotal = cart.otherCosts?.reduce((acc, cost) => acc + parseFloat(cost.price), 0) || 0;
        return formatNumberWithDecimals(baseTotal + additionalCostsTotal);
    };

    return (
        <>
            <div className={styles.totalWrapper}>
                <span className={styles.summaryText}>
                    TOTAL PRODUSE <small>(CU TVA):</small>
                </span>
                <span className={styles.summaryTotal}>{cart.totalCostWithVat ? formatNumberWithDecimals(cart.totalCostWithVat) : "Calculating..."} LEI</span>
                {renderAdditionalCosts()}
            </div>
            <div className={styles.totalPriceWrapper}>
                <span className={styles.summaryText}>
                    PRET TOTAL <small>(CU TVA)</small>:
                </span>
                <span className={styles.summaryTotal}>{calculateTotalWithOtherCosts()} LEI</span>
            </div>
        </>
    );
};

export default PriceDisplay;
